import {useContext} from "react";

import {MobileIconMenuContext} from "../internal/mobile-icon-menu-context.ts";

/**
 * Hook providing access to external state of the mobile icon menu.
 */
export const useMobileIconMenu = (): boolean =>
    useContext(MobileIconMenuContext);
